import { render, staticRenderFns } from "./contractInfo.vue?vue&type=template&id=aff88dac&scoped=true"
import script from "./contractInfo.vue?vue&type=script&lang=js"
export * from "./contractInfo.vue?vue&type=script&lang=js"
import style0 from "./contractInfo.vue?vue&type=style&index=0&id=aff88dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff88dac",
  null
  
)

export default component.exports